import clsx from "clsx";

import { BudgetMixCardMode } from "../explore-budgets/budget-mix-card/card";

type TableChartToggleProps = {
  onToggle: (toggleSelection: BudgetMixCardMode) => void;
  toggleState: BudgetMixCardMode;
};

const defaultToggleClassname =
  "w-20 border-r h-full px-2  flex flex-row items-center gap-1 border";

export const TableChartToggle = ({
  onToggle,
  toggleState,
}: TableChartToggleProps) => {
  return (
    <div className="h-8.5 flex justify-center text-center cursor-pointer text-xs">
      <div
        className={clsx("flex-center", {
          "border-r-transparent rounded-l-md": true,
          [defaultToggleClassname]: true,
          "hover:bg-v2-action-tertiary hover:border-cosmic+1 hover:border":
            toggleState === BudgetMixCardMode.TABLE,
          "bg-v2-action text-white border-transparent":
            toggleState === BudgetMixCardMode.CHART,
          "text-v2-secondary border-v2-secondary":
            toggleState === BudgetMixCardMode.TABLE,
        })}
        onClick={() => {
          if (toggleState !== BudgetMixCardMode.CHART) {
            onToggle(BudgetMixCardMode.CHART);
          }
        }}
      >
        <i className="fa-sharp fa-regular fa-chart-simple" />
        <span className="font-semibold uppercase">Chart</span>
      </div>
      <div
        className={clsx("border-l-transparent rounded-r-md flex-center", {
          [defaultToggleClassname]: true,
          "hover:bg-v2-action-tertiary hover:border-cosmic+1 hover:border":
            toggleState === BudgetMixCardMode.CHART,
          "bg-cosmic text-white border-transparent":
            toggleState !== BudgetMixCardMode.CHART,
          "text-v2-secondary border-v2-secondary":
            toggleState !== BudgetMixCardMode.TABLE,
        })}
        onClick={() => {
          if (toggleState !== BudgetMixCardMode.TABLE) {
            onToggle(BudgetMixCardMode.TABLE);
          }
        }}
      >
        <i className="fa-sharp fa-regular fa-table" />
        <span className="font-semibold uppercase">Table</span>
      </div>
    </div>
  );
};
